import { render, staticRenderFns } from "./ArtCreate.vue?vue&type=template&id=42ca7b1e&scoped=true&"
import script from "./ArtCreate.vue?vue&type=script&lang=js&"
export * from "./ArtCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca7b1e",
  null
  
)

export default component.exports